import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AppModule } from '../../app.module';
import { Document, Incident } from '../../models/incident';
import { IncidentService } from '../../shared/incident.service';
import { NotificationService } from '../../shared/notification.service';
import { mediaInfo } from '../../shared/media';

@Component({
  selector: 'app-incident-document-tile',
  imports: [AppModule],
  templateUrl: './incident-document-tile.html',
  styleUrl: './incident-document-tile.less'
})
export class IncidentDocumentTile {

  @Input() document: Document;
  @Input() incidentStatusId: number;
  @Input() incidentId: number = 0;
  @Input() canRemove: boolean = false;

  @Output() assignWorkReport = new EventEmitter<number>();
  @Output() documentRemoved = new EventEmitter<Incident>();

  constructor(private incidentService: IncidentService, private notification: NotificationService) {}

  public isTogglingPow: boolean = false;
  public isSendingPhoto = false;
  public photoQueued = false;

  public get media() { return mediaInfo(this.document); }

  public onClickAssignWorkReport(documentId: number) {
    this.assignWorkReport.emit(documentId);
  }

  public onClickSendPhoto() {
    if (this.incidentId && this.document?.documentId && !this.isSendingPhoto) {
      this.isSendingPhoto = true;
      this.photoQueued = false;
      this.incidentService.sendPhoto(this.incidentId, this.document.documentId).subscribe({
        next: () => {
          this.isSendingPhoto = false;
          this.photoQueued = true;
          this.notification.showSuccess('Queued for your WhatsApp.');
        },
        error: (error) => {
          this.isSendingPhoto = false;
          this.notification.showError(error?.error?.detail || 'Could not confirm queuing. Check WhatsApp before retrying.');
        }
      });
    }
  }

  public get isPowEnabled(): boolean {
    return this.document?.documentClassificationId === 1;
  }

  public onTogglePow(checked: boolean) {
    if (!this.incidentId || !this.document?.documentId) return;
    this.isTogglingPow = true;
    const newClassificationId = checked ? 1 : 101;
    this.incidentService.reclassifyDocument(this.document.documentId, this.incidentId, newClassificationId).subscribe({
      next: () => {
        this.document.documentClassificationId = newClassificationId;
        this.notification.showSuccess(checked ? 'Document will appear on the POW report.' : 'Document removed from POW report.');
        this.isTogglingPow = false;
      },
      error: (error) => {
        this.notification.handleError(error, 'Failed to update document POW display.');
        this.isTogglingPow = false;
      }
    });
  }

  public onClickRemoveDocument() {
    if (this.incidentId && this.document?.documentId) {
      this.incidentService.removeFileFromIncident(this.document.documentId, this.incidentId).subscribe({
        next: (incident) => {
          this.notification.showSuccess('Document removed from breakdown successfully.');
          this.documentRemoved.emit(incident);
        },
        error: (error) => {
          this.notification.handleError(error, 'Failed to remove document from breakdown.');
        }
      });
    }
  }

  public isPdf(): boolean {
    return this.media.isPdf;
  }

}
